// Generates a styled MÍDIA STORE PIX receipt as a PNG Blob using Canvas.
// No external dependencies required.

function roundRect(ctx, x, y, w, h, r) {
  const radius = Math.min(r, w / 2, h / 2);
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.arcTo(x + w, y, x + w, y + h, radius);
  ctx.arcTo(x + w, y + h, x, y + h, radius);
  ctx.arcTo(x, y + h, x, y, radius);
  ctx.arcTo(x, y, x + w, y, radius);
  ctx.closePath();
}

export function buildReceiptCanvas({ amount, txId, dateStr }) {
  const W = 720;
  const H = 1180;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  // Background
  ctx.fillStyle = "#050606";
  ctx.fillRect(0, 0, W, H);

  // Grid
  ctx.strokeStyle = "rgba(0,255,136,0.08)";
  ctx.lineWidth = 1;
  for (let x = 0; x <= W; x += 56) {
    ctx.beginPath();
    ctx.moveTo(x + 0.5, 0);
    ctx.lineTo(x + 0.5, H);
    ctx.stroke();
  }
  for (let y = 0; y <= H; y += 56) {
    ctx.beginPath();
    ctx.moveTo(0, y + 0.5);
    ctx.lineTo(W, y + 0.5);
    ctx.stroke();
  }

  // Vignette
  const grad = ctx.createRadialGradient(W / 2, H * 0.35, 80, W / 2, H * 0.5, W);
  grad.addColorStop(0, "rgba(0,255,136,0.10)");
  grad.addColorStop(1, "rgba(0,0,0,0.85)");
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, W, H);

  // Outer card
  const PAD = 36;
  ctx.shadowColor = "rgba(0,255,136,0.25)";
  ctx.shadowBlur = 40;
  ctx.fillStyle = "rgba(10,14,13,0.92)";
  roundRect(ctx, PAD, PAD, W - PAD * 2, H - PAD * 2, 28);
  ctx.fill();
  ctx.shadowBlur = 0;
  ctx.lineWidth = 2;
  ctx.strokeStyle = "rgba(0,255,136,0.45)";
  roundRect(ctx, PAD, PAD, W - PAD * 2, H - PAD * 2, 28);
  ctx.stroke();

  // Top tag
  ctx.fillStyle = "rgba(0,255,136,0.10)";
  roundRect(ctx, W / 2 - 130, 88, 260, 44, 22);
  ctx.fill();
  ctx.lineWidth = 1.5;
  ctx.strokeStyle = "rgba(0,255,136,0.55)";
  roundRect(ctx, W / 2 - 130, 88, 260, 44, 22);
  ctx.stroke();

  ctx.fillStyle = "#00ff88";
  ctx.beginPath();
  ctx.arc(W / 2 - 95, 110, 5, 0, Math.PI * 2);
  ctx.fill();

  ctx.font = "600 16px 'JetBrains Mono', 'Courier New', monospace";
  ctx.fillStyle = "#00ff88";
  ctx.textAlign = "left";
  ctx.fillText("COMPROVANTE PIX", W / 2 - 78, 117);

  // Brand
  ctx.shadowColor = "rgba(0,255,136,0.65)";
  ctx.shadowBlur = 30;
  ctx.font = "800 64px 'Poppins', 'Helvetica', sans-serif";
  ctx.fillStyle = "#00ff88";
  ctx.textAlign = "center";
  ctx.fillText("MÍDIA", W / 2 - 110, 230);
  ctx.fillStyle = "#ffffff";
  ctx.shadowColor = "rgba(255,255,255,0.5)";
  ctx.shadowBlur = 12;
  ctx.fillText("STORE", W / 2 + 110, 230);
  ctx.shadowBlur = 0;

  ctx.font = "500 18px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#7a8a82";
  ctx.fillText("SISTEMA  DE  PAGAMENTOS", W / 2, 270);

  // Status pill
  const sx = W / 2 - 180;
  const sy = 322;
  const sw = 360;
  const sh = 96;
  ctx.fillStyle = "rgba(0,255,136,0.12)";
  roundRect(ctx, sx, sy, sw, sh, 18);
  ctx.fill();
  ctx.strokeStyle = "#00ff88";
  ctx.lineWidth = 2;
  roundRect(ctx, sx, sy, sw, sh, 18);
  ctx.stroke();

  // checkmark circle
  ctx.beginPath();
  ctx.arc(sx + 50, sy + sh / 2, 22, 0, Math.PI * 2);
  ctx.fillStyle = "#00ff88";
  ctx.shadowColor = "rgba(0,255,136,0.7)";
  ctx.shadowBlur = 18;
  ctx.fill();
  ctx.shadowBlur = 0;

  ctx.strokeStyle = "#001a0f";
  ctx.lineWidth = 4;
  ctx.lineCap = "round";
  ctx.beginPath();
  ctx.moveTo(sx + 40, sy + sh / 2 + 1);
  ctx.lineTo(sx + 48, sy + sh / 2 + 9);
  ctx.lineTo(sx + 62, sy + sh / 2 - 7);
  ctx.stroke();
  ctx.lineCap = "butt";

  ctx.font = "700 30px 'Poppins', sans-serif";
  ctx.fillStyle = "#00ff88";
  ctx.shadowColor = "rgba(0,255,136,0.45)";
  ctx.shadowBlur = 14;
  ctx.textAlign = "left";
  ctx.fillText("PAGAMENTO OK", sx + 90, sy + sh / 2 + 10);
  ctx.shadowBlur = 0;

  // Divider
  ctx.strokeStyle = "rgba(0,255,136,0.18)";
  ctx.setLineDash([4, 6]);
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(80, 470);
  ctx.lineTo(W - 80, 470);
  ctx.stroke();
  ctx.setLineDash([]);

  // VALUE
  ctx.font = "500 16px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#7a8a82";
  ctx.textAlign = "center";
  ctx.fillText("VALOR PAGO", W / 2, 520);

  ctx.font = "800 96px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#ffffff";
  ctx.shadowColor = "rgba(0,255,136,0.45)";
  ctx.shadowBlur = 26;
  ctx.fillText(`R$ ${amount}`, W / 2, 620);
  ctx.shadowBlur = 0;

  // Details box
  const dx = 80;
  const dy = 700;
  const dw = W - 160;
  const dh = 280;
  ctx.fillStyle = "rgba(6,8,7,0.85)";
  roundRect(ctx, dx, dy, dw, dh, 18);
  ctx.fill();
  ctx.strokeStyle = "rgba(0,255,136,0.22)";
  ctx.lineWidth = 1.5;
  roundRect(ctx, dx, dy, dw, dh, 18);
  ctx.stroke();

  const lines = [
    ["TRANSAÇÃO", String(txId)],
    ["DATA / HORA", dateStr],
    ["MÉTODO", "PIX"],
    ["STATUS", "CONFIRMADO"],
  ];

  ctx.textAlign = "left";
  let row = dy + 50;
  lines.forEach(([k, v], i) => {
    ctx.font = "500 14px 'JetBrains Mono', monospace";
    ctx.fillStyle = "#7a8a82";
    ctx.fillText(k, dx + 28, row);

    ctx.font = "600 22px 'JetBrains Mono', monospace";
    ctx.fillStyle = i === 3 ? "#00ff88" : "#e6fff2";
    ctx.textAlign = "right";
    ctx.fillText(v, dx + dw - 28, row);
    ctx.textAlign = "left";

    if (i < lines.length - 1) {
      ctx.strokeStyle = "rgba(0,255,136,0.10)";
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(dx + 24, row + 22);
      ctx.lineTo(dx + dw - 24, row + 22);
      ctx.stroke();
    }
    row += 60;
  });

  // Footer
  ctx.font = "500 14px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#7a8a82";
  ctx.textAlign = "center";
  ctx.fillText("• POWERED BY MISTICPAY · PIX BR •", W / 2, H - 90);
  ctx.fillStyle = "rgba(0,255,136,0.7)";
  ctx.font = "600 13px 'JetBrains Mono', monospace";
  ctx.fillText("© MÍDIA STORE", W / 2, H - 65);

  return canvas;
}

export async function canvasToPngBlob(canvas) {
  return await new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error("toBlob failed"))),
      "image/png",
      0.95
    );
  });
}

export function buildWhatsAppText({ amount, txId, dateStr }) {
  return (
    `*Comprovante PIX - MÍDIA STORE*\n\n` +
    `Valor: R$ ${amount}\n` +
    `ID da transação: ${txId}\n` +
    `Data: ${dateStr}\n` +
    `Status: PAGO ✅\n\n` +
    `Segue o comprovante em anexo.`
  );
}
